module.exports = __webpack_public_path__ + "img/meyasubako-white.f3a1a434.svg";